export default __webpack_public_path__ + "static/media/BearPage1.80672c25.txt";